/*
 * @Author: your name
 * @Date: 2022-03-02 14:03:17
 * @LastEditTime: 2022-06-07 20:38:29
 * @LastEditors: chenting chenting@cqliving.com
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \share-news-detail-pages\src\common\baseConfig.ts
 */
/** 公用配置 枚举 */

/** 区县路由 */
export enum Countys {
  /** 开州 */
  "kaizhou" = 22,
  "test" = 0,
  "newchongqing" = 1,
  "wanzhou" = 28,
  "tongliang" = 10,
  "beibei" = 15,
  "fuling" = 16,
  "qijiang" = 17,
  "liangping" = 23,
  "yuzhong" = 19,
  "banan" = 34,
  "jiangjin" = 25,
  "jiulongpo" = 33,
  "lianmeng" = 71,
  "dianjiang" = 18,
  "jiangbei" = 27,
  "tongnan" = 37,
  "fengjie" = 20,
  "rongchang" = 30,
  "nanan" = 4
}

/** 各APPID */
// 不再使用该appInfo数据了，现在该数据由后端接口管理，前端统一从store里面的appInfo中拿取数据
// export enum AppInfo {
//   "新重庆" = 1,
//   "巫山" = 2,
//   "五彩石柱" = 3,
//   "掌新南岸" = 4,
//   "巫溪" = 5,
//   "人人长寿" = 6,
//   "武隆印象" = 7,
//   "今日合川" = 8,
//   "永川头条" = 9,
//   "铜梁" = 10,
//   "和美璧山" = 11,
//   "渝北掌媒" = 12,
//   "秀山e家" = 13,
//   "品位忠州" = 14,
//   "缙享北碚" = 15,
//   "爱涪陵" = 16,
//   "大美綦江" = 17,
//   "重庆垫江" = 18,
//   "在渝中" = 19,
//   "家在奉节" = 20,
//   "苗乡彭水" = 21,
//   "帅开州" = 22,
//   "家在梁平" = 23,
//   "酉州城事" = 24,
//   "最江津" = 25,
//   "家在黔江" = 26,
//   "重庆江北" = 27,
//   "看万州" = 28,
//   "幸福万盛" = 29,
//   "重庆荣昌" = 30,
//   "看丰都" = 31,
//   "今日南川" = 32,
//   "美好九龙坡" = 33,
//   "看巴南" = 34,
//   "掌上城口" = 35,
//   "沙坪坝微政务" = 36,
//   "新潼南" = 37,
//   "掌上大足" = 38,
//   "义渡热爱" = 39,
//   "智慧云阳" = 40,
//   "无线铜梁" = 41,
//   "全球渝商" = 50,
//   "重庆市政府" = 53,
//   "重庆客户端联盟" = 71
// }
